/* eslint-disable camelcase */
/* eslint-disable indent */
/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Popover from '@mui/material/Popover'
import IconButton from '@mui/material/IconButton'
import InfoIcon from '@mui/icons-material/Info'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { PropTypes } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import config from '../../config/config'
import { modalTiers } from '../../config/generalInputs.config'
import { AUTO, BICYCLE, PEDESTRIAN, TRANSIT } from '../../constants/modalTiers'
import CustomButton from '../CustomButton'
import { setActiveStep } from '../../slices/mainTool'
import { SectionTitle } from '../ProjectInputs/ProjectInputs'
import PedestrianIcon from '../../icons/PedestrianIcon'
import BicycleIcon from '../../icons/BicycleIcon'
import AutoIcon from '../../icons/AutoIcon'
import TransitIcon from '../../icons/TransitIcon'
import FreightIcon from '../../icons/FreightIcon'
import { themeConfig } from '../../config/theme.config'
import { setRoadScoreType } from '../../slices/appSlice'
import ProjectInfo from '../ProjectInputs/ProjectInfo'
import {
  URBAN_OR_WALKABLE_THOROUGHFARE,
  MAIN_STREET,
  SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL,
  SUBURBAN_CORRIDORS,
  RURAL
} from '../../config/segments.config'
import { LightTooltip } from './ModalCriteria'

export default function Scoring() {
  const dispatch = useDispatch()
  const { activeStep } = useSelector((state) => state.mainTool)
  const { roadScoreType } = useSelector((state) => state.appSlice)
  const toolTipText = {
    'Weakest Link Score':
      'Each street user’s lowest-scoring element determines their overall score.',
    'Average Score':
      'Each street user’s average score of all their elements determines their overall score.'
  }
  function handleNext() {
    dispatch(setActiveStep(activeStep + 1))
  }
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1em'
      }}
    >
      <Box
        sx={{
          display: 'grid',
          width: '60%',
          gridTemplateColumns: '40% 1fr 3%',
          alignItems: 'center',
          gap: '10px',
          justifyItems: 'self-end'
        }}
      >
        <SectionTitle>Score</SectionTitle>
        <Dropdown />
        <LightTooltip title={toolTipText[roadScoreType]} placement="top">
          <IconButton>
            <InfoIcon style={{ color: config.themeConfig.semcogGreen }} />
          </IconButton>
        </LightTooltip>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '350px',
          gap: '5px',
          width: '90%'
        }}
        className="scores-container"
      >
        {modalTiers.map((tier) => {
          return roadScoreType === 'Average Score' ? (
            <AverageScoringModal
              key={`${tier.name}-scoring`}
              name={tier.name}
              tierId={tier.id}
            />
          ) : (
            <WeakestLinkModal
              key={`${tier.name}-scoring`}
              name={tier.name}
              tierId={tier.id}
            />
          )
        })}
      </Box>
      <CustomButton handleNext={handleNext} btnLabel="Continue to Summary" />
    </Box>
  )
}

const Dropdown = () => {
  const dropDownValues = ['Average Score', 'Weakest Link Score']
  const { roadScoreType } = useSelector((state) => state.appSlice)
  const dispatch = useDispatch()

  const handleChange = (event) => {
    dispatch(setRoadScoreType(event.target.value))
  }
  return (
    <FormControl fullWidth={true} className="road-score-dropdown">
      {/* <InputLabel id="demo-simple-select-label">{}</InputLabel> */}
      <Select
        id={`${roadScoreType}-dropdown`}
        value={roadScoreType}
        onChange={handleChange}
        sx={{ m: '1em' }}
      >
        {dropDownValues.map((dropDownValue) => (
          <MenuItem key={dropDownValue} value={dropDownValue}>
            {dropDownValue}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export function AverageScoringModal({ name, tierId }) {
  const modalTierValue = useSelector((state) => state.modalTiers[name])
  const { modalPrioritization } = useSelector((state) => state)
  const avgScore = useSelector((state) => state.finalScores[tierId])
  const [rating, setRating] = useState('')
  function getKeyByValue(value) {
    return Object.keys(modalPrioritization).find(
      (key) => modalPrioritization[key] === value
    )
  }
  const priorityValue = getKeyByValue(name)
    ? getKeyByValue(name).split('_')[1]
    : ''

  useEffect(() => {
    avgScore >= 1 && avgScore <= 2.5
      ? setRating('Good')
      : avgScore > 2.5 && avgScore <= 3.5
      ? setRating('Okay')
      : avgScore > 3.5
      ? setRating('Improve')
      : setRating('')
  }, [avgScore, tierId])

  function getColor() {
    return rating === 'Good'
      ? '#4C8C44'
      : rating === 'Okay'
      ? '#f5c71a'
      : rating === 'Improve'
      ? '#e52b50'
      : '#757575'
  }

  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateRows: '10% 30% 25% 5% 20% 10%',
        justifyItems: 'center',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: config.themeConfig.lightTextColor,
          mb: '20px'
        }}
      >
        Priority: {priorityValue}
      </Typography>
      {/* <hr style={{ marginTop: '0px', borderTop: '1px solid lightGrey' }} /> */}

      {name === PEDESTRIAN ? (
        <PedestrianIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === BICYCLE ? (
        <BicycleIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === TRANSIT ? (
        <TransitIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === AUTO ? (
        <AutoIcon width="110" height="120" fill={themeConfig.semcogLightBlue} />
      ) : (
        <FreightIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      )}

      <Typography
        variant="h1"
        sx={{
          color: getColor(),
          fontWeight: 700,
          fontSize: '70px'
        }}
        className="avg-score"
      >
        {avgScore}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: getColor(),
          fontWeight: 600
        }}
      >
        {rating}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontStyle: 'italic',
          mt: '1em',
          color: config.themeConfig.lightTextColor,
          textOverflow: 'wrap',
          wordWrap: 'break-word',
          textAlign: 'center'
        }}
      >
        Modal Tier:
        <br />
        <span>{modalTierValue !== 0 ? modalTierValue : 'None'}</span>
      </Typography>
    </Box>
  )
}

export function WeakestLinkModal({ name, tierId }) {
  const modalTierValue = useSelector((state) => state.modalTiers[name])
  const { activeStep } = useSelector((state) => state.mainTool)
  const weakestScore = useSelector((state) => state.weakestLinkScores[tierId])
  const { modalPrioritization } = useSelector((state) => state)
  const { land_use_context } = useSelector((state) => state.roadwayVariables)
  const weakestLinkScore = useSelector(
    (state) => state.weakestLinkScores[tierId]
  )
  const weakestLinkVariables = useSelector(
    (state) => state.weakestLinkVariables[tierId]
  )
  const [rating, setRating] = useState('')
  function getKeyByValue(value) {
    return Object.keys(modalPrioritization).find(
      (key) => modalPrioritization[key] === value
    )
  }
  const priorityValue = getKeyByValue(name)
    ? getKeyByValue(name).split('_')[1]
    : ''

  const [anchorEl, setAnchorEl] = React.useState(null)

  // const handleOpenPopOver = (event) => {
  //   setAnchorEl(event.currentTarget)
  // }

  // const handleClose = () => {
  //   setAnchorEl(null)
  // }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? `simple-popover-${tierId}` : undefined

  const [objectiveMet, setObjectiveMet] = useState(null)

  useEffect(() => {
    switch (land_use_context) {
      case MAIN_STREET:
        setObjectiveMet(weakestScore > 0 && weakestScore <= 2)
        break
      case URBAN_OR_WALKABLE_THOROUGHFARE:
        setObjectiveMet(weakestScore > 0 && weakestScore <= 2)
        break
      case SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL:
        setObjectiveMet(weakestScore > 0 && weakestScore <= 2)
        break
      case SUBURBAN_CORRIDORS:
        setObjectiveMet(weakestScore > 0 && weakestScore <= 2)
        break
      case RURAL:
        setObjectiveMet(weakestScore > 0 && weakestScore <= 3)
        break
      default:
    }
  }, [land_use_context, weakestScore])

  // useEffect(() => {
  //   if (Object.keys(scores).length) {
  //     const fileteredScores = Object.keys(scores).filter(
  //       (key) => scores[key] !== 'NA'
  //     )
  //     const maxScore = Math.max(...fileteredScores.map((key) => scores[key]))
  //     const maxScoreVariables = fileteredScores.filter(
  //       (key) => Number(scores[key]) === maxScore
  //     )
  //     const configName = tierId + 'Config'
  //     const maxScoreVariableNames = maxScoreVariables.map(
  //       (variable) =>
  //         config[configName].find((config) => config.id === variable).name
  //     )
  //     setWeakestScoreVariables(maxScoreVariableNames)
  //     setWeakestScore(maxScore)
  //   }
  // }, [scores])

  useEffect(() => {
    weakestLinkScore >= 1 && weakestLinkScore <= 2.5
      ? setRating('Good')
      : weakestLinkScore > 2.5 && weakestLinkScore <= 3.5
      ? setRating('Okay')
      : weakestLinkScore > 3.5
      ? setRating('Improve')
      : setRating('')
  }, [weakestLinkScore, tierId])

  function getColor() {
    return rating === 'Good'
      ? '#4C8C44'
      : rating === 'Okay'
      ? '#f5c71a'
      : rating === 'Improve'
      ? '#e52b50'
      : '#757575'
  }

  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateRows: '10% 30% 25% 5% 20% 10%',
        justifyItems: 'center',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: config.themeConfig.lightTextColor,
          mb: '20px'
        }}
      >
        Priority: {priorityValue}
      </Typography>
      {/* <hr style={{ marginTop: '0px', borderTop: '1px solid lightGrey' }} /> */}

      {name === PEDESTRIAN ? (
        <PedestrianIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === BICYCLE ? (
        <BicycleIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === TRANSIT ? (
        <TransitIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      ) : name === AUTO ? (
        <AutoIcon width="110" height="120" fill={themeConfig.semcogLightBlue} />
      ) : (
        <FreightIcon
          width="115"
          height="120"
          fill={themeConfig.semcogLightBlue}
        />
      )}

      <Typography
        variant="h1"
        sx={{
          color: getColor(),
          fontWeight: 700,
          fontSize: '70px'
        }}
      >
        {weakestLinkScore}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: getColor(),
          fontWeight: 600
        }}
      >
        {rating}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontStyle: 'italic',
          mt: '1em',
          color: config.themeConfig.lightTextColor,
          textOverflow: 'wrap',
          wordWrap: 'break-word',
          textAlign: 'center'
        }}
      >
        Modal Tier:
        <br />
        <span>{modalTierValue !== 0 ? modalTierValue : 'None'}</span>
      </Typography>
      {weakestLinkVariables?.length && activeStep === 1 && rating !== 'Good' ? (
        <>
          <Box
            sx={{ cursor: 'pointer', mt: '1.5em' }}
            // onClick={handleOpenPopOver}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            <ProjectInfo infoText="Learn Why ?" />
          </Box>
          <Popover
            id={id}
            open={open}
            sx={{
              pointerEvents: 'none'
            }}
            anchorEl={anchorEl}
            // onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus={true}
          >
            <Box>
              <Typography sx={{ p: '0.5em' }}>
                Improve the score of the following:{' '}
              </Typography>
              {weakestLinkVariables?.map((variable, i) => (
                <Typography
                  sx={{ p: '0.5em', color: 'red' }}
                  key={`${variable}-weakestVariable-${i}}`}
                >
                  * {variable}
                </Typography>
              ))}
            </Box>
          </Popover>
        </>
      ) : activeStep === 2 ? (
        <Box sx={{ display: 'flex' }}>
          <Typography
            variant="body1"
            sx={{
              fontStyle: 'italic',
              mt: '1em',
              color: config.themeConfig.lightTextColor,
              textOverflow: 'wrap',
              wordWrap: 'break-word',
              textAlign: 'center'
            }}
          >
            Objective Met :{' '}
            <span
              style={{
                color: objectiveMet ? themeConfig.semcogGreen : 'red',
                fontWeight: 600
              }}
            >
              {objectiveMet ? 'YES' : 'NO'}
            </span>
          </Typography>
        </Box>
      ) : (
        <Box />
      )}
    </Box>
  )
}

AverageScoringModal.propTypes = {
  name: PropTypes.string.isRequired,
  tierId: PropTypes.string.isRequired
}
WeakestLinkModal.propTypes = {
  name: PropTypes.string.isRequired,
  tierId: PropTypes.string.isRequired
}
